import { Table, TableRow, Link, Icons, Icon, Button } from '@skf-internal/ui-components-react-legacy';
import { Manufacturer } from 'domain/shared/Manufacturer';
import { useNavigate } from 'react-router';
import { useIntl } from 'react-intl';

interface ManufacturerTableProps {
  manufacturers: Manufacturer[];
  onSortChange: (field: string, order: 'asc' | 'desc') => void;
  sortField?: string;
  sortOrder?: 'asc' | 'desc';
  onDelete: (id: number) => void;
}

const ManufacturerTable = ({ manufacturers, onSortChange, sortField, sortOrder, onDelete }: ManufacturerTableProps) => {
  const navigate = useNavigate();
  const intl = useIntl();
  const getSortIcon = (field: string) => {
    if (sortField === field) {
      return sortOrder === 'asc' ? <Icon feIcon={Icons.ArrowUp} /> : <Icon feIcon={Icons.ArrowDown} />;
    }
    return null;
  };

  const getSortableHeader = (displayName: string, fieldName: string) => ({
    children: (
      <div className="flex items-center cursor-pointer" onClick={() => onSortChange(fieldName, sortField === fieldName && sortOrder === 'asc' ? 'desc' : 'asc')}>
        {displayName} {getSortIcon(fieldName)}
      </div>
    ),
    scope: 'col'
  });

  const rows = manufacturers.map((item) => ({
    cells: [
      {
        children: (
          <Link
            className="mr-2"
            as="button"
            children={item.manufacturerName}
            onClick={() => {
              navigate(`/master-data/manufacturers/${item.manufacturerId}`);
            }}
          />
        )
      },
      { children: item.sWtg || '-' },
      { children: item.wtg || '-' },
      { children: item.gearbox || '-' },
      { children: item.generator || '-' },
      { children: item.country || '-' },
      {
        children: (
          <Button feSize="sm" feIcon={{ feIcon: Icons.Trash, position: 'left' }} onClick={() => item.manufacturerId !== undefined && onDelete(item.manufacturerId)}>
            {intl.formatMessage({ id: 'button.delete' })}
          </Button>
        )
      }
    ],
    feHighlight: true
  })) as TableRow[];

  const headers = [
    {
      cells: [
        getSortableHeader('Name', 'manufacturerName'),
        getSortableHeader('sWTG', 'sWtg'),
        getSortableHeader('WTG', 'wtg'),
        getSortableHeader('Gearbox', 'gearbox'),
        getSortableHeader('Generator', 'generator'),
        getSortableHeader('Country', 'country'),
        { children: 'Actions' }
      ]
    }
  ] as TableRow[];

  return <Table className="text-sm" feCompact feBody={rows} feHead={headers} />;
};

export default ManufacturerTable;
